/**
 * AlertManagerInitializer Component
 * 
 * A wrapper component that initializes the alert state before rendering the AlertManager.
 * This ensures that the alerts are properly loaded and initialized before the
 * AlertManager tries to access them.
 * 
 * It also ensures that all necessary CSS styles are properly loaded and applied.
 */

import React, { useEffect } from 'react';
import { useAlertContext } from '../../contexts/AlertContext';
import AlertManager from './AlertManager';
import AlertManagerStyleLoader from './AlertManagerStyleLoader';

/**
 * AlertManagerInitializer component
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.hideTitle - Whether to hide the title (useful when displayed in a Modal)
 * @returns {JSX.Element} The AlertManager component with initialized state
 */
function AlertManagerInitializer({ hideTitle = true }) {
  const { refreshAlerts, isLoading } = useAlertContext();
  
  // Initialize the alerts state when the component mounts
  useEffect(() => {
    // Refresh the alerts list
    refreshAlerts();
  }, [refreshAlerts]);
  
  // Render the AlertManager with proper styling
  return (
    <AlertManagerStyleLoader>
      <AlertManager hideTitle={hideTitle} />
    </AlertManagerStyleLoader>
  );
}

export default AlertManagerInitializer;
